module.exports = __webpack_public_path__ + "static/tridrone-891719bfb18cf561246bf4f2b12731c2.jpeg";